// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  position: relative;
}

.kam {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: max-content;
  height: 49px;
  padding: 0 15px;
  border-left: 1px solid var(--ion-color-lines);
  border-right: 1px solid var(--ion-color-lines);
  cursor: pointer;
  position: relative;
}
.kam .left {
  display: flex;
  align-items: center;
}
.kam .left .several-kams {
  display: flex;
  align-items: center;
}
.kam .left .text {
  display: flex;
  flex-direction: column;
  text-align: left;
}
.kam .plus {
  margin-left: 28px;
  transition-duration: 0.3s;
  transition-property: transform;
}
.kam .plus.down {
  transform: rotate(45deg);
}
.kam:hover {
  background: var(--ion-color-background);
}

ion-thumbnail {
  --size: 35px;
  margin-right: 8px;
  --border-radius: 100%;
  background: var(--ion-color-background);
  border: 1px solid var(--ion-color-lines);
}
ion-thumbnail.with-no-image {
  padding: 7px;
}
ion-thumbnail.no-first {
  margin-left: -20px;
}

.section {
  padding: 15px 16px;
}
.section a {
  cursor: pointer;
  text-decoration: none;
  color: unset;
  width: 100%;
}

.kam-info-several {
  display: flex;
  align-items: center;
  background: var(--ion-color-background);
  padding: 15px 16px;
  border-bottom: 1px solid var(--ion-color-lines);
}
.kam-info-several.no-first {
  border-top: 1px solid var(--ion-color-lines);
}

.kam-info {
  position: absolute;
  left: 0;
  width: 100%;
  top: 49px;
  z-index: 1;
  background: var(--ion-color-white);
  box-shadow: 0px 3px 6px rgba(2, 31, 116, 0.0509803922);
  border-radius: 0px 0px 5px 5px;
  border-top: 1px solid var(--ion-color-lines);
  overflow-x: hidden;
  overflow-y: auto;
  overscroll-behavior: contain;
  max-height: calc(100vh - 250px);
}
.kam-info .line {
  width: 100%;
  height: 0;
  border-top: 1px solid var(--ion-color-lines);
  margin: 10px 0;
}`, "",{"version":3,"sources":["webpack://./src/app/components/header-kams/header-kams.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,6CAAA;EACA,8CAAA;EACA,eAAA;EACA,kBAAA;AACF;AAGE;EACE,aAAA;EACA,mBAAA;AADJ;AAGI;EACE,aAAA;EACA,mBAAA;AADN;AAII;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;AAFN;AASE;EACE,iBAAA;EACA,yBAAA;EACA,8BAAA;AAPJ;AASI;EACE,wBAAA;AAPN;AAWE;EACE,uCAAA;AATJ;;AAcA;EACE,YAAA;EACA,iBAAA;EACA,qBAAA;EACA,uCAAA;EACA,wCAAA;AAXF;AAaE;EACE,YAAA;AAXJ;AAcE;EACE,kBAAA;AAZJ;;AAgBA;EACE,kBAAA;AAbF;AAeE;EACE,eAAA;EACA,qBAAA;EACA,YAAA;EACA,WAAA;AAbJ;;AAiBA;EACE,aAAA;EACA,mBAAA;EACA,uCAAA;EACA,kBAAA;EACA,+CAAA;AAdF;AAgBE;EACE,4CAAA;AAdJ;;AAkBA;EACE,kBAAA;EACA,OAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,kCAAA;EACA,sDAAA;EACA,8BAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;EACA,4BAAA;EACA,+BAAA;AAfF;AAiBE;EACE,WAAA;EACA,SAAA;EACA,4CAAA;EACA,cAAA;AAfJ","sourcesContent":[":host {\n  position: relative;\n}\n\n.kam {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: max-content;\n  height: 49px;\n  padding: 0 15px;\n  border-left: 1px solid var(--ion-color-lines);\n  border-right: 1px solid var(--ion-color-lines);\n  cursor: pointer;\n  position: relative;\n\n\n\n  .left {\n    display: flex;\n    align-items: center;\n\n    .several-kams {\n      display: flex;\n      align-items: center;\n    }\n\n    .text {\n      display: flex;\n      flex-direction: column;\n      text-align: left;\n    }\n\n  }\n\n\n\n  .plus {\n    margin-left: 28px;\n    transition-duration: 0.3s;\n    transition-property: transform;\n\n    &.down {\n      transform: rotate(45deg);\n    }\n  }\n\n  &:hover {\n    background: var(--ion-color-background);\n  }\n}\n\n\nion-thumbnail {\n  --size: 35px;\n  margin-right: 8px;\n  --border-radius: 100%;\n  background: var(--ion-color-background);\n  border: 1px solid var(--ion-color-lines);\n\n  &.with-no-image {\n    padding: 7px;\n  }\n\n  &.no-first {\n    margin-left: -20px;\n  }\n}\n\n.section {\n  padding: 15px 16px;\n\n  a {\n    cursor: pointer;\n    text-decoration: none;\n    color: unset;\n    width: 100%;\n  }\n}\n\n.kam-info-several {\n  display: flex;\n  align-items: center;\n  background: var(--ion-color-background);\n  padding: 15px 16px;\n  border-bottom: 1px solid var(--ion-color-lines);\n\n  &.no-first {\n    border-top: 1px solid var(--ion-color-lines);\n  }\n}\n\n.kam-info {\n  position: absolute;\n  left: 0;\n  width: 100%;\n  top: 49px;\n  z-index: 1;\n  background: var(--ion-color-white);\n  box-shadow: 0px 3px 6px #021F740D;\n  border-radius: 0px 0px 5px 5px;\n  border-top: 1px solid var(--ion-color-lines);\n  overflow-x: hidden;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  max-height: calc(100vh - 250px);\n\n  .line {\n    width: 100%;\n    height: 0;\n    border-top: 1px solid var(--ion-color-lines);\n    margin: 10px 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
